export const API_ENDPOINTS = {
  app: {
    version: { url: '/version', method: 'GET' },
  },
  /** Client error reports → middle structured logs (session auth). */
  clientErrors: { url: '/client-errors', method: 'POST', type: 'application/json' },
  user: {
    signUp: { url: '/user/signup', method: 'POST' },
    changePassword: { url: '/user/changePassword', method: 'POST' },
    signout: { url: '/user/signout', method: 'GET' },
    signIn: { url: '/user/signin', method: 'POST', type: 'application/json' },
    signInByCard: { url: '/user/signinByCard', method: 'POST', type: 'application/json' },
    getSystemsList: { url: '/user/systems', method: 'GET' },
    retrieve: { url: '/user/retrieve', method: 'POST', type: 'application/json' },
    resend: { url: '/user/signup/resend/approve', method: 'POST' },
    approveRetrieve: { url: '/user/retrieve/approve', method: 'POST', type: 'application/json' },
    approveSignup: { url: '/user/signup/approve/${token}', method: 'GET' },
    get: { url: '/user', method: 'GET' },
    feedback: { url: '/user/feedback', method: 'POST', type: 'application/json' },
    refreshToken: { url: '/user/refresh-token', method: 'POST' },
    platformConnectionStatus: {
      url: '/user/platform-connection-status',
      method: 'GET',
      responseType: 'text',
    },
    changeUser: { url: '/user/change-user', method: 'POST', type: 'application/json' },
  },
  platform: {
    heartbeat: { url: 'portal/heartbeat', method: 'POST', type: 'application/json' },
    config: { url: '/platform/config', method: 'GET' },
    startupActionsPending: { url: '/platform/startup-actions/pending', method: 'GET' },
    action: { url: '/platform/action', method: 'POST' },
    reloadForm: { url: '/platform/reload/form', method: 'POST' },
    reloadPanel: { url: '/platform/reload/panel', method: 'POST' },
    reloadElement: { url: '/platform/reload/element', method: 'POST' },
    executeProcedure: { url: '/platform/execute-procedure', method: 'POST' },
    executeScript: { url: '/platform/executeScript', method: 'POST' },
    subscribe: {
      method: 'POST',
      url: '/platform/subscribe',
      isSse: true,
    },
    subscribeWS: {
      url: '/api/platform/subscribe-web-socket',
      isWebSocket: true,
    },
    remove: { url: '/platform/remove', method: 'POST' },
    getFile: {
      url: '/platform/download',
      headers: {
        Accept: 'multipart/mixed',
      },
      method: 'GET',
    },
    upload: {
      url: '/platform/upload',
      type: undefined,
      method: 'POST',
      uploading: true,
      responseType: 'json',
    },
    /** WUI-305: подготовка сессии DS (multipart + JSON request). */
    officeEditorPrepare: {
      url: '/platform/office-editor/prepare',
      method: 'POST',
      uploading: true,
      responseType: 'json',
    },
    /** WUI-316: опрос sync-state при timeout `awaiting_ws`; body: `storage_uri`. */
    officeEditorDocumentSyncState: {
      url: '/platform/office-editor/document-sync-state',
      method: 'POST',
      type: 'application/json',
      responseType: 'json',
    },
    /** WUI-316: отмена незавершённого save-цикла (диалог «Отменить»). */
    officeEditorDiscard: {
      url: '/platform/office-editor/discard',
      method: 'POST',
      type: 'application/json',
      responseType: 'json',
    },
    /** Form-save: middle → DS Command Service `forcesave`. */
    officeEditorForceSave: {
      url: '/platform/office-editor/forcesave',
      method: 'POST',
      type: 'application/json',
      responseType: 'json',
    },
  },
} as const

export default API_ENDPOINTS
